"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowInfoCard = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Yup = __importStar(require("yup"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const core_ui_1 = require("@sierralabs/core-ui");
const react_material_ui_formik_1 = require("@sierralabs/react-material-ui-formik");
const workflow_core_1 = require("@sierralabs/workflow-core");
const useFindWorkflows_1 = require("../hooks/useFindWorkflows");
const useUpdateWorkflow_1 = require("../hooks/useUpdateWorkflow");
const TaskTypePicker_1 = require("../task-types/pickers/TaskTypePicker");
const WorkflowBuilderContext_1 = require("../WorkflowBuilderContext");
const StyledGrid = (0, styled_components_1.default)(core_1.Grid) `
  display: flex;
  flex-direction: column;
`;
function getInitialValues(workflow) {
    return {
        name: (workflow === null || workflow === void 0 ? void 0 : workflow.name) || '',
        taskPath: workflow === null || workflow === void 0 ? void 0 : workflow.taskPath,
        taskTypeId: workflow === null || workflow === void 0 ? void 0 : workflow.taskTypeId,
        description: (workflow === null || workflow === void 0 ? void 0 : workflow.description) || ''
    };
}
const WorkflowInfoCard = props => {
    var _a, _b, _c;
    const { workflow, onChange } = props;
    const onChangeRef = (0, react_1.useRef)(onChange);
    const formikRef = (0, react_1.useRef)(null);
    const { taskTypes } = (0, WorkflowBuilderContext_1.useWorkflowBuilderContext)();
    const { data: updatedWorkflow, isLoading: isUpdating, error: updateError, updateWorkflow } = (0, useUpdateWorkflow_1.useUpdateWorkflow)(workflow.id);
    // find conflicting workflows for specific task type
    const { workflowList, isLoading, findWorkflows } = (0, useFindWorkflows_1.useFindWorkflows)();
    const workflowListRef = (0, react_1.useRef)(workflowList);
    const [initialValues, setInitialValues] = (0, react_1.useState)(() => {
        return getInitialValues(workflow);
    });
    const [updateWorkflowDto, setUpdateWorkflowDto] = (0, react_1.useState)();
    const [openEntityConfirm, setOpenEntityConfirm] = (0, react_1.useState)(false);
    const isPublished = workflow.status === workflow_core_1.WorkflowStatus.Published;
    (0, react_1.useEffect)(() => {
        onChangeRef.current = onChange;
    }, [onChange]);
    (0, react_1.useEffect)(() => {
        setInitialValues(getInitialValues(workflow));
    }, [workflow]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (updatedWorkflow) {
            (_a = onChangeRef.current) === null || _a === void 0 ? void 0 : _a.call(onChangeRef, updatedWorkflow);
        }
    }, [updatedWorkflow]);
    (0, react_1.useEffect)(() => {
        // check if conflicting workflows for entity
        if (!(workflowList &&
            workflowListRef.current !== workflowList &&
            !isLoading &&
            !isUpdating)) {
            return;
        }
        if (workflowList.data.length > 0 &&
            workflowList.data[0].id !== workflow.id) {
            workflowListRef.current = workflowList;
            setOpenEntityConfirm(true);
        }
        else if (workflowList.data.length === 0 && updateWorkflowDto) {
            // if no conflict then update
            updateWorkflow(updateWorkflowDto);
            workflowListRef.current = workflowList;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateWorkflow, updateWorkflowDto, workflow.id, workflowList]);
    return (react_1.default.createElement(core_1.Card, null,
        react_1.default.createElement(core_ui_1.CardTitle, null,
            react_1.default.createElement(icons_1.LocalLibrary, null),
            "Workflow Info"),
        react_1.default.createElement(core_ui_1.CardContent, { padding: 'large' },
            react_1.default.createElement(react_material_ui_formik_1.InlineFormik, { innerRef: ref => (formikRef.current = ref), error: updateError, initialValues: initialValues, isSubmitting: isUpdating || isLoading, validationSchema: Yup.object({
                    name: Yup.string().required('Required'),
                    taskPath: Yup.string()
                        .optional()
                        .nullable()
                        .matches(/:id/g, 'Should have ":id"')
                }), onSubmit: dto => updateWorkflow(dto) },
                react_1.default.createElement(react_material_ui_formik_1.InlineForm, null,
                    react_1.default.createElement(react_material_ui_formik_1.InlineTextField, { name: 'name', label: 'Name', disabled: isPublished, placeholder: 'Provide a name for the workflow.' }),
                    react_1.default.createElement(StyledGrid, { item: true, xs: 12 },
                        react_1.default.createElement(core_1.Typography, { variant: 'h5', gutterBottom: true }, "Task Type"),
                        react_1.default.createElement(TaskTypePicker_1.TaskTypePicker, { options: taskTypes, disabled: isPublished, value: workflow.taskTypeId, textFieldProps: { label: undefined }, onChange: taskType => {
                                const taskTypeId = taskType === null || taskType === void 0 ? void 0 : taskType.id;
                                setUpdateWorkflowDto({
                                    taskTypeId,
                                    taskType: taskType || undefined
                                });
                                findWorkflows({ taskTypeId, includeDeleted: true });
                            } })),
                    react_1.default.createElement(react_material_ui_formik_1.InlineTextField, { multiline: true, name: 'description', label: 'Description', placeholder: 'Provide an overview of the workflow.', disabled: isPublished }),
                    react_1.default.createElement(react_material_ui_formik_1.InlineTextField, { multiline: true, name: 'taskPath', label: 'Task Redirect Path', placeholder: 'Enter the email redirect path to Task.', disabled: isPublished }),
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 12, style: { paddingTop: 0 } },
                        react_1.default.createElement(core_1.FormHelperText, { style: { marginLeft: 10 } }, "Redirect path used for links in Task email notifications."))))),
        react_1.default.createElement(core_ui_1.ConfirmDialog, { title: 'Override Entity Workflow', message: react_1.default.createElement(react_1.default.Fragment, null,
                "This will replace \"", (_a = workflowList === null || workflowList === void 0 ? void 0 : workflowList.data[0]) === null || _a === void 0 ? void 0 :
                _a.name,
                "\" as the default workflow for Task Type \"", (_b = updateWorkflowDto === null || updateWorkflowDto === void 0 ? void 0 : updateWorkflowDto.taskType) === null || _b === void 0 ? void 0 :
                _b.label,
                " (", (_c = updateWorkflowDto === null || updateWorkflowDto === void 0 ? void 0 : updateWorkflowDto.taskType) === null || _c === void 0 ? void 0 :
                _c.prefix,
                ")\"."), open: !!updateWorkflowDto && openEntityConfirm, onCancel: () => {
                setOpenEntityConfirm(false);
                setUpdateWorkflowDto({ taskTypeId: initialValues === null || initialValues === void 0 ? void 0 : initialValues.taskTypeId });
            }, onConfirm: () => {
                setOpenEntityConfirm(false);
                updateWorkflowDto && updateWorkflow(updateWorkflowDto);
            } }),
        react_1.default.createElement(core_ui_1.AppSnackbar, { severity: 'error', open: !!updateError }, updateError === null || updateError === void 0 ? void 0 : updateError.message)));
};
exports.WorkflowInfoCard = WorkflowInfoCard;
exports.default = exports.WorkflowInfoCard;
//# sourceMappingURL=WorkflowInfoCard.js.map